import { gql } from '@apollo/client'

export default gql`
  fragment CourseProjectPreview on CourseProject {
    id
    title
  }
`
